const io = require('socket.io-client');
export default (_url) => {
    return io(_url, {
        'reconnection': true,
        'reconnectionDelay': 2000,
        'reconnectionDelayMax': 5000,
    });
};
